<template>
  <div
    class="pagination"
  >
    <div
      class="previous-container"
      @click="$emit('previous-page', currentFilterResults)"
    >
      <icon
        v-if="currentFilterResults.page > 1"
        class="arrow-icon"
        name="mastery-arrow-left"
        variant="b2b2b2"
      />
    </div>
    <div class="counter">
      {{ currentFilterResults.page }} of {{ totalPages }}
    </div>
    <div
      class="next-container"
      @click="$emit('next-page', currentFilterResults)"
    >
      <icon
        v-if="currentFilterResults.page < totalPages"
        class="arrow-icon"
        name="mastery-arrow-right"
        variant="b2b2b2"
      />
    </div>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  components: { Icon },
  props: {
    currentFilterResults: {
      type: Object,
    },
    totalPages: {
      type: Number,
      default: 1,
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  align-items: center;
  display: flex;
  justify-content: center;

  .arrow-icon {
    height: 16px;
    width: 16px;
  }

  .previous-container, .next-container {
    cursor: pointer;
    min-width: 16px;
  }

  .previous-container {
    margin-right: 8px;
  }

  .next-container {
    margin-left: 8px;
  }
}
</style>